module.exports = __webpack_public_path__ + "static/img/diodo-1.ca86185.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/diodo-1.svg
// module id = Zv0a
// module chunks = 0